import {
  IAddQuestionPayload,
  IQuestion,
  TUpdateQuestionPayload,
} from "@/types/questions.types";
import { HTTP_METHODS } from "@/constants/HttpConstants";
import { sendRequestToInterviewWithCredential } from "@/utils/request.utils";
import { Dictionary } from "@/types/utils.types";

export const getAllQuestionsAPI = (interviewSlug: string) =>
  sendRequestToInterviewWithCredential<Dictionary<IQuestion>>({
    method: HTTP_METHODS.GET,
    url: `/interviews/${interviewSlug}/questions/`,
  });

export const addQuestionAPI = (
  interviewSlug: string,
  payload: IAddQuestionPayload,
) =>
  sendRequestToInterviewWithCredential<IQuestion>({
    method: HTTP_METHODS.POST,
    url: `/interviews/${interviewSlug}/questions/`,
    data: payload,
  });

export const updateQuestionAPI = (
  interviewSlug: string,
  questionSlug: string,
  payload: TUpdateQuestionPayload,
) =>
  sendRequestToInterviewWithCredential<IQuestion>({
    method: HTTP_METHODS.PUT,
    url: `/interviews/${interviewSlug}/questions/${questionSlug}/`,
    data: payload,
  });

export const getQuestionAPI = (interviewSlug: string, questionSlug: string) =>
  sendRequestToInterviewWithCredential({
    method: HTTP_METHODS.GET,
    url: `/interviews/${interviewSlug}/questions/${questionSlug}/`,
  });

export const removeQuestionAPI = (
  interviewSlug: string,
  questionSlug: string,
) =>
  sendRequestToInterviewWithCredential({
    method: HTTP_METHODS.DELETE,
    url: `/interviews/${interviewSlug}/questions/${questionSlug}/`,
  });
